import z from 'zod';
import { MapPointValidationSchema } from './mapPoint';
import { UUIDValidationSchema } from './uuid';
const BaseMappedRemedyValidationSchema = z.object({
    workshopId: UUIDValidationSchema,
    sketchId: UUIDValidationSchema,
    remedy: z.object({
        key: z.string()
    }),
    location: MapPointValidationSchema,
    footprintCoordinates: z.array(z.array(z.number()).length(2)).optional(),
    footprintAreaSqFt: z.number().positive(),
    notes: z.string().optional()
});
export const AddMappedRemedyValidationSchema = BaseMappedRemedyValidationSchema;
export const MappedRemedyValidationSchema = BaseMappedRemedyValidationSchema.extend({
    _id: UUIDValidationSchema
});
//# sourceMappingURL=mappedRemedy.js.map